import React, { useState } from 'react';
import classNames from 'classnames';

import css from './SubscriptionAlert.module.css';

const SubscriptionAlert = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <div className={css.subscriptionAlert}>
      <button
        className={css.subscriptionBar}
        onClick={toggleExpand}
        aria-expanded={isExpanded}
        aria-controls="subscription-options"
        aria-label="Toggle subscription options"
      >
        <div className={css.subscriptionBarContent}>
          <div className={css.subscriptionBarLeft}>
            <div className={css.alertIcon}>⚠️</div>
            <p className={css.subscriptionMessage}>
              Please subscribe to start accepting inquiries.
            </p>
          </div>
          <div className={css.subscriptionBarRight}>
            <span className={css.chooseText}>Choose subscription</span>
            <span
              className={classNames(css.arrow, { [css.expanded]: isExpanded })}
              aria-hidden="true"
            >
              ▼
            </span>
          </div>
        </div>
      </button>
      {isExpanded && (
        <div id="subscription-options" className={css.subscriptionOptions}>
          <a
            href="https://buy.stripe.com/28o15kcvW5eU7TO7sv"
            target="_blank"
            rel="noopener noreferrer"
            className={css.subscriptionLink}
            onClick={() => {
              // Analytics tracking can be added here
            }}
          >
            <span className={css.subscriptionLinkContent}>
              <span className={css.subscriptionLinkTitle}>Monthly Subscription</span>
              <span className={css.subscriptionLinkSubtitle}>Billed monthly</span>
            </span>
            <span className={css.subscriptionLinkArrow}>→</span>
          </a>
          <a
            href="https://buy.stripe.com/aEUg0ecvWePu7TOeUW"
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(css.subscriptionLink, css.subscriptionLinkYearly)}
            onClick={() => {
              // Analytics tracking can be added here
            }}
          >
            <span className={css.subscriptionLinkContent}>
              <span className={css.subscriptionLinkTitle}>Yearly Subscription</span>
              <span className={css.subscriptionLinkSubtitle}>Best value - Save more</span>
            </span>
            <span className={css.subscriptionLinkArrow}>→</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default SubscriptionAlert;
